(function () {
  'use strict';

  var drawer = null;
  var moneyFormatter = null;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char];
    });
  }

  function formatMoney(cents) {
    try {
      moneyFormatter = moneyFormatter || new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: window.HotLoveCurrency || 'PLN'
      });
      return moneyFormatter.format((cents || 0) / 100);
    } catch (error) {
      return ((cents || 0) / 100).toFixed(2) + ' zł';
    }
  }

  function updateBadges(count) {
    qsa('[data-hl-cart-count]').forEach(function (badge) {
      badge.textContent = count || 0;
      badge.classList.toggle('on', (count || 0) > 0);
    });
  }

  function renderCart(cart) {
    var itemsEl = qs('[data-hl-cart-items]');
    var totalEl = qs('[data-hl-cart-total]');
    var titleEl = qs('[data-hl-cart-title]');
    if (!itemsEl || !cart) return;

    updateBadges(cart.item_count || 0);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);
    if (titleEl) titleEl.textContent = (cart.item_count || 0) + ' produkty';

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="hl-cart-empty">Twój koszyk jest pusty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var image = item.image || '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="hl-cart-item__variant">' + escapeHtml(item.variant_title) + '</span>'
        : '';
      return [
        '<article class="hl-cart-item">',
          image ? '<img src="' + escapeHtml(image) + '&width=160" alt="' + escapeHtml(item.product_title) + '">' : '<div></div>',
          '<div class="hl-cart-item__info">',
            '<a class="hl-cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>',
            variant,
            '<div class="hl-cart-item__meta">',
              '<div class="hl-cart-qty">',
                '<button type="button" data-hl-cart-change="' + escapeHtml(item.key) + '" data-hl-cart-qty="' + (item.quantity - 1) + '" aria-label="Zmniejsz ilość">-</button>',
                '<span>' + item.quantity + '</span>',
                '<button type="button" data-hl-cart-change="' + escapeHtml(item.key) + '" data-hl-cart-qty="' + (item.quantity + 1) + '" aria-label="Zwiększ ilość">+</button>',
              '</div>',
              '<strong>' + formatMoney(item.final_line_price) + '</strong>',
            '</div>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  async function fetchCart() {
    var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
    renderCart(cart);
    return cart;
  }

  function openCart() {
    drawer = drawer || qs('[data-hl-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hl-cart-open');
    fetchCart().catch(function () {});
  }

  function closeCart() {
    drawer = drawer || qs('[data-hl-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hl-cart-open');
  }

  function initCart(root) {
    qsa('[data-hl-cart-open]', root).forEach(function (trigger) {
      if (trigger.dataset.hlBound) return;
      trigger.dataset.hlBound = 'true';
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openCart();
      });
    });

    qsa('[data-hl-cart-close]', root).forEach(function (trigger) {
      if (trigger.dataset.hlBound) return;
      trigger.dataset.hlBound = 'true';
      trigger.addEventListener('click', closeCart);
    });

    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-hl-cart-change]');
      if (!button) return;
      event.preventDefault();
      button.disabled = true;
      try {
        var cart = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: button.getAttribute('data-hl-cart-change'), quantity: Number(button.getAttribute('data-hl-cart-qty')) })
        }).then(function (response) { return response.json(); });
        renderCart(cart);
      } finally {
        button.disabled = false;
      }
    });
  }

  function initAjaxForms(root) {
    qsa('form.hl-ajax-form', root).forEach(function (form) {
      if (form.dataset.hlBound) return;
      form.dataset.hlBound = 'true';

      form.addEventListener('submit', async function (event) {
        var submitter = event.submitter || document.activeElement;
        if (!submitter || !submitter.matches('[data-hl-add-cart]')) return;

        event.preventDefault();
        var button = submitter;
        var originalText = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = form.getAttribute('data-loading-text') || 'Dodawanie...';
        }

        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Cart add failed');
          await fetchCart();
          if (button) button.textContent = form.getAttribute('data-added-text') || 'Dodano';
          window.setTimeout(openCart, 120);
        } catch (error) {
          if (button) button.textContent = form.getAttribute('data-error-text') || 'Spróbuj ponownie';
        } finally {
          window.setTimeout(function () {
            if (!button) return;
            button.disabled = false;
            button.textContent = originalText;
          }, 1500);
        }
      });
    });
  }

  function initGalleries(root) {
    qsa('[data-hl-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.hlBound) return;
      gallery.dataset.hlBound = 'true';
      qsa('[data-hl-target]', gallery).forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-hl-target');
          qsa('[data-hl-target]', gallery).forEach(function (item) {
            item.classList.toggle('is-active', item === button);
          });
          qsa('[data-hl-media]', gallery).forEach(function (media) {
            media.classList.toggle('is-active', media.getAttribute('data-hl-media') === target);
          });
        });
      });
    });
  }

  function initPopups(root) {
    qsa('[data-hl-popup]', root).forEach(function (popup) {
      if (popup.dataset.hlBound) return;
      popup.dataset.hlBound = 'true';
      var key = popup.getAttribute('data-hl-popup-key') || 'hotlove-popup';

      function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('hl-popup-open');
      }

      qsa('[data-hl-popup-close]', popup).forEach(function (button) {
        button.addEventListener('click', closePopup);
      });

      window.setTimeout(function () {
        try {
          if (window.sessionStorage.getItem(key) === '1') return;
          window.sessionStorage.setItem(key, '1');
        } catch (error) {}
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('hl-popup-open');
      }, 700);
    });
  }

  function initStickyBuy(root) {
    qsa('[data-hl-sticky-buy]', root).forEach(function (bar) {
      if (bar.dataset.hlStickyBound) return;
      bar.dataset.hlStickyBound = 'true';

      var formId = bar.getAttribute('data-hl-sticky-form');
      var form = formId ? document.getElementById(formId) : null;
      var mobileQuery = window.matchMedia('(max-width: 640px)');

      function updateStickyBuy() {
        if (!mobileQuery.matches || !form) {
          bar.classList.remove('is-visible');
          return;
        }

        var formRect = form.getBoundingClientRect();
        var shouldShow = formRect.bottom < 84;
        bar.classList.toggle('is-visible', shouldShow);
      }

      updateStickyBuy();
      window.addEventListener('scroll', updateStickyBuy, { passive: true });
      window.addEventListener('resize', updateStickyBuy);
    });
  }

  function init(root) {
    root = root || document;
    initCart(root);
    initAjaxForms(root);
    initGalleries(root);
    initPopups(root);
    initStickyBuy(root);
    fetchCart().catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCart();
      qsa('[data-hl-popup].is-open').forEach(function (popup) {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
      });
      document.documentElement.classList.remove('hl-popup-open');
    }
  });
})();
